import CustomSnackbar from "../components/Common/CustomSnackbar";
import ParserConfigReport from "../components/ParserConfigReport/index";
import { useSnackbar } from "../components/Common/hooks/useSnackbar";

const ParserSimulate = () => {
  const { snackbarProps } = useSnackbar();

  return (
    <>
      <div className="panel-container">
        <ParserConfigReport />
      </div>
      <CustomSnackbar {...snackbarProps} />
    </>
  );
};

export default ParserSimulate;
